// extracted by mini-css-extract-plugin
export default {"headMain":"List_headMain__NBZq1","pad0":"List_pad0__EkORn","id":"List_id__WOTDB","btntbl":"List_btntbl__-HUAF","btns":"List_btns__ider-"};